meedy.controller('meedy.popupFirstConfigurationController', ['$scope', '$state', '$translate', '$mdDialog',
    'meedy.availabilityRuleModel', 'mode', 'meedy.userModel', 'userModel', 'meedy.resourceModel', 'meedy.dictionaryModel',
    'meedy.wizardModel', 'meedy.accountingModel',
    function ($scope, $state, $translate, $mdDialog, availabilityRuleModel, mode, userModel, edmUserModel, resourceModel,
              dictionaryModel, wizardModel, accountingModel) {

        function setData() {
            $scope.title = 'T.MEEDY.MODULE.TITLE.WIZARD';

            $scope.loading = false;

            $scope.tabs = [];
            $scope.tabs.push({name : 'T.MEEDY.UI.TABBAR.WIZARD.FILL_YOUR_DATA'});
            if(mode != Enum.MEEDY.INCOMPLETE_DATA.MY_DATA_ONLY) {
                $scope.tabs.push({name : 'T.MEEDY.UI.TABBAR.WIZARD.ADD_OFFICE'});
                $scope.tabs.push({name : 'T.MEEDY.UI.TABBAR.WIZARD.WELCOME_HOURS'});
            }

            $scope.currentTab = $scope.tabs[0];

            $scope.wrapper = new FirstConfigurationWrapperMeedyVO();
            $scope.wrapper.myData = new MyDataWrapperMeedyVO();
            $scope.wrapper.myData.medicalPostAccounting = new MedicalPostAccountingMeedyVO();
            $scope.wrapper.myData.physicianDetails = new PhysicianDetailsMeedyVO();
            $scope.wrapper.myData.user = new UserMeedyVO();
            $scope.wrapper.myData.medicalPost = new MedicalPostMeedyVO();
            $scope.wrapper.availabilityRule = new AvailabilityRuleMeedyVO();
            $scope.wrapper.resource = new ResourceMeedyVO();

            $scope.forms = {
                myData : null,
                office : null,
                availability : null
            };

            // myData

            $scope.criteria = new ResourceDataGridMeedyCriteria();
            $scope.criteria.rowsPerSheet = 99;

            $scope.address = undefined;
            $scope.selectedAddress = undefined;
            $scope.addressPointer = 1;

            $scope.phoneRegExp = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{3})/;
            $scope.stateList = [];
            $scope.specializationList = [];
            $scope.academicTitleList = [];

            $scope.pwzRequired = false;

            $scope.vm = {
                searchTitle : null
            };

            $scope.forms = {
                myData : null
            };

            $scope.officeAddresses = [];
            $scope.ageList = [
                {value : 0, label : $translate.instant('T.MEEDY.MODULE.MY_DATA.UNDER') + ' 1 ' + $translate.instant('T.MEEDY.MODULE.MY_DATA.YEAR') },
                {value : 1, label : '1 ' + $translate.instant('T.MEEDY.MODULE.MY_DATA.YEAR') }
            ];
            for(var i = 2; i < 19; i++) {
                $scope.ageList.push({value : i, label : i + ' ' + $translate.instant('T.MEEDY.MODULE.MY_DATA.YEARS') });
            }

            // office

            $scope.colors = ['#ff0e42', '#1b98f3', '#4cb04f', '#ff9a02', '#a52497', '#919ea8', '#ffef48'];
            $scope.wrapper.resource.color = $scope.colors[0];

            $scope.minutes = availabilityRuleModel.generateAppointmentTimeOptions().map(function(time) { return {value: time, label: time+' min'} });

            // availability

            $scope.now = new Date();

            $scope.monday = {
                label : 'T.MEEDY.ENUM.DAY_TYPE.MONDAY',
                dayType : Enum.MEEDY.DAY_TYPE.MONDAY,
                dayDefinitions: [],
                emptyDayDefinition : new AvailabilityRuleDayDefinitionMeedyVO,
                focus: '#monStart'
            };
            $scope.tuesday = {
                label : 'T.MEEDY.ENUM.DAY_TYPE.TUESDAY',
                dayType : Enum.MEEDY.DAY_TYPE.TUESDAY,
                dayDefinitions: [],
                emptyDayDefinition : new AvailabilityRuleDayDefinitionMeedyVO,
                focus: '#tuesdayStart'
            };
            $scope.wednesday = {
                label : 'T.MEEDY.ENUM.DAY_TYPE.WEDNESDAY',
                dayType : Enum.MEEDY.DAY_TYPE.WEDNESDAY,
                dayDefinitions: [],
                emptyDayDefinition : new AvailabilityRuleDayDefinitionMeedyVO,
                focus: '#thursdayStart'
            };
            $scope.thursday = {
                label : 'T.MEEDY.ENUM.DAY_TYPE.THURSDAY',
                dayType : Enum.MEEDY.DAY_TYPE.THURSDAY,
                dayDefinitions: [],
                emptyDayDefinition : new AvailabilityRuleDayDefinitionMeedyVO,
                focus: '#thursdayStart'
            };
            $scope.friday = {
                label : 'T.MEEDY.ENUM.DAY_TYPE.FRIDAY',
                dayType : Enum.MEEDY.DAY_TYPE.FRIDAY,
                dayDefinitions: [],
                emptyDayDefinition : new AvailabilityRuleDayDefinitionMeedyVO,
                focus: '#fridayStart'
            };
            $scope.saturday = {
                label : 'T.MEEDY.ENUM.DAY_TYPE.SATURDAY',
                dayType : Enum.MEEDY.DAY_TYPE.SATURDAY,
                dayDefinitions: [],
                emptyDayDefinition : new AvailabilityRuleDayDefinitionMeedyVO,
                focus: '#saturdayStart'
            };
            $scope.sunday = {
                label : 'T.MEEDY.ENUM.DAY_TYPE.SUNDAY',
                dayType : Enum.MEEDY.DAY_TYPE.SUNDAY,
                dayDefinitions: [],
                emptyDayDefinition : new AvailabilityRuleDayDefinitionMeedyVO,
                focus: '#sundayStart'
            };

            $scope.days = {
                monday: $scope.monday,
                tuesday: $scope.tuesday,
                wednesday: $scope.wednesday,
                thursday: $scope.thursday,
                friday: $scope.friday,
                saturday: $scope.saturday,
                sunday: $scope.sunday
            };

            $scope.duplicatedNip = false;
            $scope.duplicatedRegon = false;
            $scope.duplicatedPwz = false;

            //

            $scope.Enum = Enum;
        }

        function setPermissions() {
        }

        function setListeners() {

            $scope.$on(Event.MEEDY.USER.GET_MY_DATA.SUCCESS, function(event, wrapper) {
                $scope.wrapper.myData = wrapper;

                if(!$scope.wrapper.myData.medicalPostAccounting) {
                    $scope.wrapper.myData.medicalPostAccounting = new MedicalPostAccountingMeedyVO();
                }

                if(!$scope.wrapper.myData.physicianDetails) {
                    $scope.wrapper.myData.physicianDetails = new PhysicianDetailsMeedyVO();
                }

                if(!$scope.wrapper.myData.user) {
                    $scope.wrapper.myData.user = new UserMeedyVO();
                }

                if(!$scope.wrapper.myData.medicalPost) {
                    $scope.wrapper.myData.medicalPost = new MedicalPostMeedyVO();
                }

                switch($scope.wrapper.myData.medicalPost.correspondenceAddressType) {
                    case Enum.MEEDY.CORRESPONDENCE_ADDRESS_TYPE.MEDICAL_POST:
                        $scope.addressPointer = 1;
                        break;
                    case Enum.MEEDY.CORRESPONDENCE_ADDRESS_TYPE.OTHER:
                        $scope.addressPointer = 3;
                        $scope.addres  = $scope.wrapper.myData.medicalPost.correspondenceAddressOther;
                        break;
                    default :
                        $scope.wrapper.myData.medicalPost.correspondenceAddressType = Enum.MEEDY.CORRESPONDENCE_ADDRESS_TYPE.MEDICAL_POST;
                        break;
                }

                $scope.address = $scope.wrapper.myData.medicalPost.correspondenceAddressOther;
            });

            $scope.$on(Event.MEEDY.WIZARD.SAVE_FIRST_CONFIGURATION.SUCCESS, function(event, data) {
                $scope.loading = false;
                userModel.getLoggedUser().then(function (meedyUser) {
                    if(meedyUser.inEdm) {
                        edmUserModel.getLoggedUser();
                    }
                });
                $state.reload();
                $mdDialog.hide();
            });

            $scope.$on(Event.MEEDY.DICTIONARY.GET_STATES.SUCCESS, function(event, dataPage) {
                $scope.stateList = dataPage.data;
            });

            $scope.$on(Event.MEEDY.DICTIONARY.GET_SPECIALIZATIONS.SUCCESS, function(event, dataPage) {
                $scope.specializationList = dataPage.data;
            });

            $scope.$on(Event.MEEDY.USER.PWZ_EXISTENCE.SUCCESS, function(event, answer) {
                $scope.duplicatedPwz = answer.exists;
                $scope.forms.myData["myData.pwz"].$validate();
            });
            $scope.$on(Event.MEEDY.ACCOUNTING.NIP_EXISTENCE.SUCCESS, function(event, answer) {
                $scope.duplicatedNip = answer.exists;
                $scope.forms.myData['myData.nip'].$validate();
            });
            $scope.$on(Event.MEEDY.ACCOUNTING.REGON_EXISTENCE.SUCCESS, function(event, answer) {
                $scope.duplicatedRegon = answer.exists;
                $scope.forms.myData['myData.regon'].$validate();
            });

            $scope.$on(Event.MEEDY.DICTIONARY.GET_ACADEMIC_TITLES.SUCCESS, function(event, dataPage) {
                for(var i = 0; i < dataPage.data.length; i++) {
                    $scope.academicTitleList.push(dataPage.data[i].name);
                }
            });


            $scope.$watch('wrapper.myData.physicianDetails.allowChildren', function(newValue, oldValue){
                if(newValue === false) {
                    $scope.wrapper.myData.physicianDetails.childrenAgeLowerLimit = undefined;
                    $scope.wrapper.myData.physicianDetails.childrenAgeUpperLimit = undefined;
                }
            });

            $scope.$watch('wrapper.myData.physicianDetails.firstSpecialization', function(newValue, oldValue){
                $scope.evaluatePwzRequirement();
            });

            $scope.$watch('wrapper.myData.physicianDetails.secondSpecialization', function(newValue, oldValue){
                $scope.evaluatePwzRequirement();
            });

            $scope.$watch('addressPointer', function(newValue, oldValue){
                switch(newValue) {
                    case 1:
                        $scope.address = $scope.wrapper.myData.medicalPost.address;
                        $scope.wrapper.myData.medicalPost.correspondenceAddressResourceId = null;
                        $scope.wrapper.myData.medicalPost.correspondenceAddressType = Enum.MEEDY.CORRESPONDENCE_ADDRESS_TYPE.MEDICAL_POST;
                        break;
                    case 2:
                        if($scope.selectedAddress) {
                            $scope.address = $scope.selectedAddress.address;
                            $scope.wrapper.myData.medicalPost.correspondenceAddressResourceId = $scope.selectedAddress.id;
                        }
                        $scope.wrapper.myData.medicalPost.correspondenceAddressType = Enum.MEEDY.CORRESPONDENCE_ADDRESS_TYPE.RESOURCE;
                        break;
                    case 3:
                        if($scope.wrapper.myData.medicalPost.correspondenceAddressOther) {
                            $scope.address = $scope.wrapper.myData.medicalPost.correspondenceAddressOther;
                        } else {
                            $scope.address = new AddressMeedyVO();
                        }
                        $scope.wrapper.myData.medicalPost.correspondenceAddressResourceId = null;
                        $scope.wrapper.myData.medicalPost.correspondenceAddressType = Enum.MEEDY.CORRESPONDENCE_ADDRESS_TYPE.OTHER;
                        break;
                }
            });

            $scope.onSelectedAddressChange = function(newValue, oldValue) {
                if($scope.addressPointer == 2 && newValue) {
                    $scope.address = newValue.address;
                    $scope.selectedAddress = newValue;
                    $scope.wrapper.myData.medicalPost.correspondenceAddressResourceId = newValue.id;
                }
            }

            $scope.evaluatePwzRequirement = function() {
                var wrapper = $scope.wrapper;
                if (wrapper) {
                    console.log(wrapper);
                    var physicianDetails = wrapper.myData.physicianDetails;
                    var firstSpecialization = physicianDetails.firstSpecialization;
                    var secondSpecialization = physicianDetails.secondSpecialization;
                    $scope.pwzRequired = (firstSpecialization && firstSpecialization.pwzRequired)
                        || (secondSpecialization && secondSpecialization.pwzRequired);
                }
            }
        }

        function setActions() {
            $scope.trimBankAccount = function() {
                if($scope.wrapper.myData.medicalPostAccounting && $scope.wrapper.myData.medicalPostAccounting.accountNumber) {
                    $scope.wrapper.myData.medicalPostAccounting.accountNumber = $scope.wrapper.myData.medicalPostAccounting.accountNumber.replace(/ /g, '');
                }
            };

            $scope.continue = function() {
                var form = undefined;
                switch($scope.currentTab) {
                    case ($scope.tabs[0]):
                        form = $scope.forms.myData;
                        $scope.wrapper.myData.physicianDetails.title = $scope.vm.searchTitle;
                        break;
                    case ($scope.tabs[1]):
                        form = $scope.forms.office;
                        break;
                    case ($scope.tabs[2]):
                        form = $scope.forms.availability;
                        break;
                }

                form.$setSubmitted();
                if(form.$valid) {

                    switch($scope.currentTab) {
                        case ($scope.tabs[0]):
                            if(mode != Enum.MEEDY.INCOMPLETE_DATA.MY_DATA_ONLY) {
                                $scope.currentTab = $scope.tabs[1];
                            } else {
                                $scope.save();
                            }
                            break;
                        case ($scope.tabs[1]):
                            $scope.currentTab = $scope.tabs[2];
                            break;
                        case ($scope.tabs[2]):
                            $scope.save();
                            break;
                    }
                }

            };

            $scope.save = function () {

                if(mode != Enum.MEEDY.INCOMPLETE_DATA.MY_DATA_ONLY) {
                    $scope.wrapper.availabilityRule.dayDefinitions = _.union($scope.monday.dayDefinitions,
                        $scope.tuesday.dayDefinitions, $scope.wednesday.dayDefinitions, $scope.thursday.dayDefinitions,
                        $scope.friday.dayDefinitions, $scope.saturday.dayDefinitions, $scope.sunday.dayDefinitions);
                }

                $scope.loading = true;

                wizardModel.saveFirstConfiguration($scope.wrapper);
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.validateNip = function() {
                if($scope.wrapper.myData.medicalPostAccounting.nip) {
                    accountingModel.nipExistence($scope.wrapper.myData.medicalPostAccounting.nip);
                }
            };

            $scope.validateRegon = function() {
                if($scope.wrapper.myData.medicalPostAccounting.regon) {
                    accountingModel.regonExistence($scope.wrapper.myData.medicalPostAccounting.regon);
                }
            };

            $scope.validatePwz = function() {
                if($scope.wrapper.myData.physicianDetails.pwz) {
                    userModel.pwzExistence($scope.wrapper.myData.physicianDetails.pwz);
                }
            };

            $scope.newAcademicTitle = function(searchText) {
                $scope.academicTitleList.push(searchText);
            };

            $scope.getMatches = function(query) {
                var results = [];

                for(var i = 0; i < $scope.academicTitleList.length; i++) {
                    if($scope.academicTitleList[i].indexOf(query) > -1) {
                        results.push($scope.academicTitleList[i]);
                    }
                }

                return results;
            };

            $scope.addAvailability = function(day) {
                if(day.emptyDayDefinition.startTime && day.emptyDayDefinition.endTime) {
                    var dayDefinition = new AvailabilityRuleDayDefinitionMeedyVO();
                    dayDefinition.startTime = new Date(day.emptyDayDefinition.startTime);
                    dayDefinition.endTime = new Date(day.emptyDayDefinition.endTime);
                    dayDefinition.day= day.dayType;

                    day.emptyDayDefinition = new AvailabilityRuleDayDefinitionMeedyVO();

                    day.dayDefinitions.push(dayDefinition);
                    $('#' + $(day.focus + ' input')[0].id).focus();
                }
            };

            $scope.selectIcon = function(variable) {
                return !variable;
            };

            $scope.removeAvailability = function(availability, day) {
                var dayDefinitions = day.dayDefinitions;

                day.dayDefinitions = _.remove(dayDefinitions, function(dayDefinition) {
                    return !(availability.startTime == dayDefinition.startTime && availability.endTime == dayDefinition.endTime);
                });
            };

            $scope.return = function() {
                switch($scope.currentTab) {
                    case ($scope.tabs[1]):
                        $scope.currentTab = $scope.tabs[0];
                        break;
                    case ($scope.tabs[2]):
                        $scope.currentTab = $scope.tabs[1];
                        break;
                }
            }
        }

        function initialize() {
            userModel.getMyData();
            dictionaryModel.getStates();
            dictionaryModel.getSpecializations();
            dictionaryModel.getAcademicTitles();

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        initialize();
    }
]);